import { render, staticRenderFns } from "./DataPoolOptimizer.vue?vue&type=template&id=725372be&"
import script from "./DataPoolOptimizer.vue?vue&type=script&lang=js&"
export * from "./DataPoolOptimizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports